import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './LandingBlockPartner.css';

const propTypes = {
  title: PropTypes.string,
  partnerName: PropTypes.string,
  logo: PropTypes.string,
};

const defaultProps = {
  title: null,
  partnerName: null,
};

class LandingBlockPartner extends PureComponent {
  render() {
    const { children, logo, partnerName, title } = this.props;

    return (
      <div className="LandingBlockPartner">
        <div className="LandingBlockPartner-text">
          <h2 className="LandingBlockPartner-text-heading">{title}</h2>
          {children}
        </div>
        <div className="LandingBlockPartner-branding">
          <img
            className="LandingBlockPartner-branding-logo"
            src={logo}
            alt={`${partnerName} logo`}
          />
        </div>
      </div>
    );
  }
}

LandingBlockPartner.propTypes = propTypes;
LandingBlockPartner.defaultProps = defaultProps;

export default LandingBlockPartner;
